import axios, { AxiosInstance } from 'axios'
import { message } from 'ant-design-vue'
import store from '@/store'
import { getToken, setLoginTime } from '@/utils/auth'
import { Base64 } from 'js-base64'
import website from '@/utils/website'
import { serialize, getLocalLanguage } from '@/utils/index'
import router from '@/router'
import { refreshToken } from '@/utils/refreshToken'
import i18n from '@/locales'
import { encodeFormParam, decodeList } from './transcode'
import { checkReleasePlan } from './versionPrompt'

// create an axios instance
const service = axios.create({
  // baseURL: window.API_URL,
  baseURL: '/api',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000,
})

service.interceptors.request.use(
  (config: any) => {
    config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`
    config.headers['Accept-Language'] = getLocalLanguage('')
    if (store.getters.token) {
      config.headers['Blade-Auth'] = `Bearer ${getToken()}`
    }
    // 登录接口的特殊处理
    if (config.url.indexOf('auth/token') > -1) {
      config.data = serialize(config.data)
      return config
    } else {
      config = encodeFormParam(config)
      let interval = null
      let retry = new Promise((resolve, reject) => {
        const refreshFun = () =>
          refreshToken().then(res => {
            // 判断是否刷新token,且成功了
            if (res && res === 'success') {
              console.log('刷新token！！！')
              config.headers['Blade-Auth'] = `Bearer ${getToken()}`
              // 挂起请求
              resolve(config)
            } else if (res && res === 'pending') {
              if (interval) {
                clearInterval(interval)
                interval = null
              }
              console.log('等待刷新token！！！')
              interval = setInterval(() => {
                refreshFun()
              }, 500)
            } else {
              // 不需要刷新token或刷新失败
              // 等待刷新成功后就不需要再刷新，此时需重新赋值新token
              if (interval) {
                console.log('等待成功！')
                config.headers['Blade-Auth'] = `Bearer ${getToken()}`
                clearInterval(interval)
              }
              // 挂起请求
              resolve(config)
            }
          })
        refreshFun()
      })
      return retry
    }
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.data.success || typeof response.data.success === 'undefined') {
     /* if(response.config.responseType==='blob') {
        let size = response.data&&response.data.size ? response.data.size: 0
        if(size>999999) {
          return Promise.reject("文件内容过大，无法在线预览，请下载后查看！")
        }
      }*/
      // mock数据
      if (response.data.status && typeof response.data.status === 'undefined') {
        response.data.status = 200
      }

      // 记录登录返回的时间
      if (response.config.url.indexOf('auth/token') > -1) {
        setLoginTime(String(new Date().getTime()))
      }
      response = decodeList(response)
      if(response.config.url != '/blade-system/release-plan'){
        checkReleasePlan()
      }

      return Promise.resolve(response.data.code ? response : response.data)
    }
    response.data.msg && message.error(i18n.t(response.data.msg))
    return Promise.reject(response.data.msg)
  },
  error => {
    /*const err = error.response.data.error.message.slice(1, -1)
    const status = err.status
    if (err.length > 30) {
      message.error(status)
    } else {
      message.error(i18n.t(err))
    }*/
    // console.log('error:', error.response)
    if (error.response.status && error.response.status === 401) {
      store.dispatch('user/logout')
      router.push('/login')
    } else if (error.response.status && error.response.status === 404) {
      // 404不做处理
    } else {
      if (error.response.data instanceof Blob) {
        const data = error.response.data
        const reader = new FileReader()
        reader.readAsText(data, 'utf-8')
        reader.onload = function() {
          const d = JSON.parse(reader.result as string)
          message.error(i18n.t(d.msg))
        }
      }

      // 异常信息不弹出，先console记录
      if (error.response.data.msg && error.response.data.msg.length < 100) {
        let errMsg: any = i18n.t(error.response.data.msg)
        // 配置了错误提示显示时间
        if (error.response.config.duration) {
          message.error({ content: errMsg, duration: error.response.config.duration })
        } else {
          message.error(errMsg)
        }
      }
    }
    return Promise.reject(error)
  }
)

export default service as AxiosInstance
